import {EChannelType, TChannelType} from 'src/constants';
import {EType, TMessageMatcher} from 'src/containers/MessageMatchers/definitions';
import {TItem as TParameterItem} from 'src/containers/Parameters/definitions';
import {getParametersOptions} from 'src/containers/Parameters/utils';
import {EMarkup, parseMarkdown} from 'src/utils';

const getTextRegex = (channelType: TChannelType, type: TMessageMatcher['type']) => {
  if (type === EType.CUSTOM) {
    return;
  }

  if (channelType === EChannelType.SMS) {
    return /%[dw]\S*/g;
  }

  return;
};

const insertVariableText = (contentText: string, parameters: TParameterItem[]) => {
  const variableOptions = getParametersOptions(parameters);

  return contentText.replace(/({{([^{}]+)}})/g, (_, text, id) => {
    const option = variableOptions.find((item) => String(item.id) === String(id));

    if (option) {
      return option.value;
    }

    return text;
  });
};

const HTML_CODE: Record<string, string> = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#039;',
};

const escapeHtml = (text: string) => text.replace(/[&<>"']/g, (value) => HTML_CODE[value]);

const prepareMessageText = ({
  text,
  channelType,
}: {
  text?: string | null;
  channelType: TMessageMatcher['channelType'];
}) => {
  if (!text) {
    return '';
  }

  const escapedText = escapeHtml(text);

  if ([EChannelType.VIBER, EChannelType.WHATSAPP].includes(channelType as EChannelType)) {
    return parseMarkdown(escapedText);
  }

  return parseMarkdown(escapedText, [EMarkup.LINK]);
};

type TSpan = {
  theme: TTheme['theme'];
  text: string;
};

const makePlaceholderSpan = ({theme, text}: TSpan) =>
  `<span style="color: ${theme.palette.green500}">${text}</span>`;
const makeVariableSpan = ({theme, text}: TSpan) =>
  `<span style="color: ${theme.palette.pink500}; font-weight: 600">${text}</span>`;
const makeEmptyVariableSpan = ({theme, text}: TSpan) =>
  `<span style="color: ${theme.branding.content.secondary}; font-weight: 600">${text}</span>`;

const FOOTER_TIME = '12:00';

const MAX_MESSAGE_WIDTH = '254px';

export {
  FOOTER_TIME,
  MAX_MESSAGE_WIDTH,
  prepareMessageText,
  insertVariableText,
  getTextRegex,
  makeVariableSpan,
  makeEmptyVariableSpan,
  makePlaceholderSpan,
};
